<template>
  <!-- 角色管理 -->
  <div class="page-container">
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
          <el-input v-model="filterForm.roleName" placeholder="角色名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.createUser" placeholder="创建人" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="查询"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="getReset"
            type="primary"/>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-plus"
            label="新增"
            perms="31110"
            type="primary"
            @click="handleAdd"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      :data="roleList"
      stripe
      size="mini"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        width="50"
        align="center"
        fixed
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="roleName"
        align="center"
        label="角色名称"
      ></el-table-column>
      <el-table-column
        prop="staffNumber"
        align="center"
        label="关联员工数"
      ></el-table-column>
      <el-table-column
        prop="createUser"
        align="center"
        label="创建人"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        align="center"
        label="注册时间"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        align="left"
        width="200"
        show-overflow-tooltip
        label="操作"
      >
        <template slot-scope="scope">
          <kt-button
            icon="fa fa-edit"
            label="修改"
            perms="31111"
            @click="handleEdit(scope.row)"
          />
          <kt-button
            icon="fa fa-trash"
            label="删除"
            perms="31112"
            type="danger"
            @click="handleDelete(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding: 20px">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      ></el-pagination>
    </div>
    <!-- 添加角色弹窗 -->
    <el-dialog 
      width="50%"
      label-position="center"
      :title="dialogTitle"
      :visible.sync="roleDialogVisible"
			:lock-scroll="true"
      custom-class="dialogClass"
      :close-on-click-modal="false"
      :before-close="handleClose">
        <el-form
          class="roleForm"
          :model="roleForm" 
          :rules="roleRules" 
          ref="roleForm" 
          label-width="70px"
          :size="size"
          label-position="left"
          @keyup.enter.native="submitRoleForm()">
          <div class="baseInfo">
            <div class="title">基础信息</div>
            <el-row>
              <el-col :span="10">
                <el-form-item label="角色名" prop="roleName">
                  <el-input v-model="roleForm.roleName" placeholder="请输入角色名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="funcPerms">
            <div class="title">功能权限</div>
            <el-tree
              :data="funcData"
              show-checkbox
              check-strictly
              node-key="resourceId"
              ref="roleTree"
              :default-checked-keys="roleForm.resourceIdList"
              :props="defaultProps">
            </el-tree>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button :size="size" @click="handleClose">取消</el-button>
          <el-button :size="size" type="primary" @click="submitRoleForm">保存</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
export default {
  components: {
    KtButton,
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      roleList: [], //角色列表
      dialogTitle: '新增',
      roleDialogVisible: false,
      filterForm: {},
      roleForm: {
        roleName: '',
        resourceIdList: []
      },
      roleRules: {
        roleName: [{ required: true, message: "请输入角色名", trigger: "blur" }],
      },
      funcData: [],
      defaultProps: {
        children: 'subNodeList',
        label: 'name'
      }
    };
  },
  mounted() {
    this.getRoleList();
    this.getFuncPerms();
  },
  methods: {
    // 获取角色列表
    async getRoleList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      let index = 0
      for (let key in this.filterForm) {
        const val = this.filterForm[key]
        if (val && val !== '') {
          params['searchFieldList[' + index + '].fieldName'] = key
          params['searchFieldList[' + index + '].singleValue'] = val
          index++
        }
      }
      let res = await this.$api.system.mGetRoleList(params)
      // console.log(res)
      this.roleList = res.data.dtoList;
      this.totalSize = res.data.totalSize;
    },

    // 获取所有功能权限
    async getFuncPerms(){
      let res = await this.$api.system.mGetFuncPerms()
      this.funcData = res.data
    },

    // 重新设计后台返回的数据结构 
    // setFuncData(list){
    //   let target = []
    //   list.forEach(item => {
    //     if(Object.prototype.toString.call(item) !== '[object Object]') return target.push(item)
    //     target.push({
    //       type: item.resourceId,
    //       label: item.name,
    //       children: item.subNodeList.length > 0 ? this.setFuncData(item.subNodeList) : []
    //     })
    //   })

    //   return target
    // },

    // 保存角色
    async submitRoleForm(){
      let halfCheckedKeys = this.$refs.roleTree.getHalfCheckedKeys()
      let checkKeys = this.$refs.roleTree.getCheckedKeys()
      this.$refs['roleForm'].validate(async (valid) => {
        if (valid) {
          let params = {
            roleName: this.roleForm.roleName,
            resourceIdList: halfCheckedKeys.concat(checkKeys)
          }
          if(this.roleForm.roleId) Object.assign(params, {
            roleId: this.roleForm.roleId
          })
          let res = await this.$api.system.mSaveRole(params)
          this.roleDialogVisible = false
          this.$refs['roleForm'].resetFields()
          this.$message({ message: "保存成功", type: "success" });
          this.getRoleList()
        }
      })
      
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getRoleList();
    },
    //搜索
    handleSearch() {
      this.pageNo = 1;
      this.getRoleList();
    },

    // 重置搜索
    getReset() {
      this.filterForm = {}
      this.getRoleList()
    },

    // 关闭弹窗
    handleClose() {
      this.$refs.roleTree.setCheckedKeys([])
      this.roleDialogVisible = false
      this.$refs['roleForm'].resetFields()
      this.roleForm = {}
    },

    // 显示新增界面
    handleAdd() {
      this.dialogTitle = '新增'
      this.roleForm = {}
      this.roleDialogVisible = true
    },

    // 显示编辑界面
    async handleEdit(row) {
      this.dialogTitle = '编辑'
      let res = await this.$api.system.mGetRoleDetail({
        roleId: row.roleId
      })

      this.roleDialogVisible = true;
      // this.roleForm = {
      //   ...res.data,
      // };
      let newList = []
      let resourceIdList = res.data.resourceIdList
      this.$nextTick(() => {
        resourceIdList.forEach((i,n) => {
          let node = this.$refs.roleTree.getNode(i);
          // if(node.isLeaf){
            // this.$refs.roleTree.setChecked(node, true);
            newList.push(node.data.resourceId)
          // }
          
        });
        console.log(res.data.resourceIdList,newList);
        this.roleForm = {
          ...res.data,
          resourceIdList: newList
        }
        
      })
    },

    //删除
    handleDelete(row) {
      this.$confirm("确认删除该记录吗？", "提示", {
        type: "warning",
      }).then(async () => {
        let res = await this.$api.system.mDeleteRole({
          roleId: row.roleId,
        })

        if(+res.code === 0){
          this.getRoleList();
          this.$message({ message: "删除成功", type: "success" });
        }

      });
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  padding: 10px 10px 30px;
  box-sizing: border-box;
}
.dialogClass .el-dialog__body{
  background: #f1f1f1;
}
.title{
  height: 50px;
  line-height: 50px;
}
</style>